import type { CSSProperties } from "react";

import { resolveUrl } from "../lib/api";

export interface IconSource {
  name: string;
  icon_url: string | null;
  icon_background?: string | null;
}

/** App icon on its tile. Dark mode swaps the app's light tile for a neutral one (CSS). */
export function AppIcon({ app, size = 56 }: { app: IconSource; size?: number }) {
  const style = { width: size, height: size, fontSize: size * 0.42, "--tile-bg": app.icon_background ?? undefined } as CSSProperties;
  return (
    <span className="app-icon" style={style}>
      {app.icon_url ? <img src={resolveUrl(app.icon_url)} alt="" /> : app.name.slice(0, 1).toUpperCase()}
    </span>
  );
}

export function initials(name: string): string {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .map((p) => p[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
}

export function Avatar({ name, url, size = 40 }: { name: string; url?: string; size?: number }) {
  return (
    <span className="avatar" style={{ width: size, height: size, fontSize: Math.round(size * 0.38) }}>
      {url ? <img src={resolveUrl(url)} alt="" /> : initials(name)}
    </span>
  );
}
